import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { CommentEstblishmentComponent } from "./components/commentEstblishment/commentEstblishment.component";
import { CommentDeliveryComponent } from "./components/commentDelivery/commentDelivery.component";
import { ConfettiService } from '../../../../../shared/confetti';
import { NotificationsService } from '../../../../../shared/components/notifications/service/notifications.service';

@Component({
  selector: 'detail-order-modal-view-rate',
  imports: [CommonModule, CommentEstblishmentComponent, CommentDeliveryComponent],
  templateUrl: `./modal-view-rate.component.html`,
  styleUrl: './modal-view-rate.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalViewRateComponent implements OnInit, OnChanges {
  isOpen = signal(false)
  isAnimating = signal(false)
  @Input() data: { isCommentDelivery: boolean, isCommentEstablishment: boolean, shoppingCart: string } = {
    isCommentDelivery: false,
    isCommentEstablishment: false,
    shoppingCart: ''
  }
  notificationService = inject(NotificationsService);
  constructor(private confettiService: ConfettiService) {

  }
  ngOnInit(): void {
    // Abrir modal cuando ambos están en false O cuando solo uno está en true
    // NO abrir cuando ambos están en true
    if (!(this.data.isCommentDelivery && this.data.isCommentEstablishment)) {
      this.openModalWithAnimation();
    } else {
      this.isOpen.set(false);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      // Actualizar el estado del modal cuando cambian los datos
      // Abrir modal cuando ambos están en false O cuando solo uno está en true
      // NO abrir cuando ambos están en true
      if (!(this.data.isCommentDelivery && this.data.isCommentEstablishment)) {
        this.openModalWithAnimation();
      } else {
        this.closeModalWithAnimation();
      }
    }
  }


  openModal(): void {
    if (this.isOpen()) {
      this.closeModalWithAnimation();
    } else {
      this.openModalWithAnimation();
    }
  }

  openModalWithAnimation(): void {
    this.isOpen.set(true);
    setTimeout(() => {
      this.isAnimating.set(true);
    }, 10);
  }

  closeModal(): void {
    this.closeModalWithAnimation();
  }

  closeModalWithAnimation(): void {
    this.isAnimating.set(false);
    setTimeout(() => {
      this.isOpen.set(false);
    }, 300);
  }

  confetti(): void {
    this.confettiService.heartsFromSides();
  }

  onFormSent(success: boolean): void {
    if (success) {
      this.confetti();
      this.notificationService.addNotification({
        message: 'Comentario enviado con éxito',
        type: 'success',
      });
    }
  }
}
